import { render } from "./CeoSection.vue?vue&type=template&id=170f5053&scoped=true"
import script from "./CeoSection.vue?vue&type=script&lang=js"
export * from "./CeoSection.vue?vue&type=script&lang=js"

import "./CeoSection.vue?vue&type=style&index=0&id=170f5053&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170f5053"]])

export default __exports__